export const executiveCommercial = {
  id: "executive-commercial",
  name: "Executive Commercial",

  scene: {
    backgroundImage: null,
    baseColor: "#0F141A",
    radialGlow: "radial-gradient(ellipse at 50% 44%, rgba(39,225,193,0.10) 0%, rgba(39,225,193,0.04) 46%, transparent 72%)",
    overlayTint: "rgba(8, 14, 18, 0.34)",
    vignette: 0.58,
    parallaxStrength: 0.32,
    particleType: "none",
  },

  glass: {
    bg: "rgba(18,28,36,0.72)",
    blur: 18,
    border: "rgba(39,225,193,0.15)",
    radius: 22,
  },

  glow: {
    edgeColor: "rgba(39, 225, 193, 0.60)",
    edgeStrength: 0.35,
    heroBoost: 0.6,
  },

  accent: {
    primary: "#27E1C1",
    secondary: "#5A8CA0",
  },

  numeric: {
    positive: "#22c55e",
    warning: "#f59e0b",
    danger: "#ef4444",
  },

  ai: {
    orbStyle: "bot",
    orbGlow: "rgba(39,225,193,0.35)",
  },

  tokens: {
    "--tl-bg-0": "#0F141A",
    "--tl-bg-1": "#0B1015",
    "--tl-bg-2": "#060a0e",
    "--tl-text-0": "#e0eef4",
    "--tl-text-1": "#b8ccd8",
    "--tl-text-muted": "#7a94a8",
    "--tl-accent-0": "#27E1C1",
    "--tl-accent-1": "#5A8CA0",
    "--tl-glass-bg": "rgba(18, 28, 36, 0.72)",
    "--tl-glass-border": "rgba(39, 225, 193, 0.15)",
    "--tl-glass-blur": "18px",
    "--tl-glass-shadow": "0 12px 36px rgba(0,0,0,0.50)",
    "--tl-glass-glow-color": "rgba(39,225,193,0.3)",
    "--tl-glow-edge-color": "rgba(39, 225, 193, 0.60)",
    "--tl-glow-edge-strength": "0.35",
    "--tl-glow-hero-boost": "0.6",
    "--tl-radius": "22px",
    "--tl-molten-wordmark-gradient": "none",
  },
};
